'use client';

import { useEffect, useState, type ReactNode } from 'react';
import { useTranslations } from 'next-intl';

/**
 * Ticking countdown to a UTC instant (WFA-2).
 *
 * Renders em-dashes on the server and during hydration, then starts ticking on
 * mount — computing from Date.now() during render would make the server and
 * client HTML disagree and trip a hydration warning. The dash frame has the
 * same geometry as the numbers, so the swap does not shift layout.
 */
export function Countdown({ target, doneLabel }: { target: string; doneLabel: ReactNode }) {
  const t = useTranslations('components.countdown');
  const [now, setNow] = useState<number | null>(null);

  useEffect(() => {
    setNow(Date.now());
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, []);

  const remainingMs = now === null ? null : new Date(target).getTime() - now;

  if (remainingMs !== null && remainingMs <= 0) {
    return <p className="countdown-done">{doneLabel}</p>;
  }

  const totalSeconds = remainingMs === null ? null : Math.floor(remainingMs / 1000);
  const parts =
    totalSeconds === null
      ? [null, null, null, null]
      : [
          Math.floor(totalSeconds / 86_400),
          Math.floor((totalSeconds % 86_400) / 3600),
          Math.floor((totalSeconds % 3600) / 60),
          totalSeconds % 60,
        ];
  const labels = [t('days'), t('hours'), 'min', 'sec'];

  return (
    <div className="countdown-clock" role="timer" aria-label={t("label")}>
  {parts.map((value, i) => (
    <div className="cd-group" key={labels[i]}>
      <div className="cd-tile">
        {/* <span className="cd-num">
          {value === null ? "—" : String(value).padStart(2, "0")}
        </span> */}
        <span
  className={`cd-num ${i === 0 || i === 2 ? "cd-num-white-mobile" : ""}`}
>
  {value === null ? "—" : String(value).padStart(2, "0")}
</span>

        <span className="cd-label">{labels[i]}</span>
      </div>

      {i < parts.length - 1 && (
        <span className="cd-separator">:</span>
      )}
    </div>
  ))}
</div>
  );
}
